import loaderCF from "../assets/img/icon.png"

export default function Loading() {
  return (
    <div className=" h-96 w-96 flex justify-center items-center bg-white">
      <img src={loaderCF} className="w-32 h-32 rounded-full" alt="Loader CULM"/>
    </div>
  );
}
